// import { playVimeo } from "./plyr/vimeo"; 

import { isMobile, select } from "./Helper";


import { initSlider } from "./sliders/slider";
import { initTabSlider } from "./sliders/tab-slider";
import { inithomeSlider } from "./sliders/home-slider"
import { createTimelineSlider } from "./sliders/timeline-slider";
import { menu, menuClose, checkCurrentPage, menuAccordian } from "./menu/menu";
import { createLazyLoad, destroyLazyLoad } from "./animations/lazyLoad";
import { siteSearch } from "./site-search/site-search";
import { accordianView } from './components/accordian';
import { SocialShareKit } from "./components/social-share-kit.min";

// import { headerActive } from "./lenis/lenis.js";

import { venoboxInit } from "./siteFun";
import { createBannerSlider } from "./sliders/our-business-slider.js";

window.SocialShareKit = SocialShareKit;
menu();


function init() {
    siteSearch();
    createLazyLoad();
    // playVimeo();  
    checkCurrentPage();
    initSlider();
    initTabSlider();
    inithomeSlider();
    createTimelineSlider();
    createBannerSlider();
    menuAccordian();
    accordianView();
    venoboxInit();
    // simpleParalax();
    // cardOverlap();
    // headerActive();

    setTimeout(() => {
        SocialShareKit.init();

        if (document.querySelector('.news-details')) {
            document.querySelector('header')?.classList.add('white');
        } else {
            document.querySelector('header')?.classList.remove('white');
        }

    }, 100);


    // Check if device is mobile using screen width
    if (isMobile()) {
        const topHeader1 = document.querySelector("header");

        window.addEventListener('scroll', () => {
            if (window.scrollY > 1) {
                topHeader1.classList.add("active");
            } else {
                topHeader1.classList.remove("active");
            }
        });
    }




}


function initBeforeEnter() {
    menuClose();

    const cfForms = document.querySelectorAll(".wpcf7 form");

    if (cfForms.length > 0 && typeof wpcf7 !== "undefined" && typeof wpcf7.init === "function") {
        cfForms.forEach(function (form) {
            wpcf7.init(form);
        });
    }


}

function destroyBeforeLeave() {
    destroyLazyLoad();
}

export { init, initBeforeEnter, destroyBeforeLeave };